import { queryAll } from '../utils/dom'
import { substitute } from '../utils/String'
import StoreDropdown from './StoreDropdown'

export default class StoreDropdownFilter extends StoreDropdown {
    constructor(element) {
        super(element)

        this.ref = {
            ...super.ref,
            itemTemplate: null,
            list: null,
        }
    }

    prepare() {
        const items = queryAll('[data-filteritem]').map((element) => ({
            url: element.href,
            stateClasses: element.classList.contains('is-active') ? 'is-active' : '',
            content: element.querySelector('.toolbar-Control-content').innerText,
        }))

        const itemTemplate = this.ref.itemTemplate.innerText.trim()
        const itemsHTML = items.map((item) => substitute(itemTemplate, item)).join('')
        this.ref.list.innerHTML = itemsHTML

        super.prepare()
    }
}
